import { UserRound } from "lucide-react";
import { PILLARS } from "../data/proposal";
import { SectionHead } from "./SectionHead";

export const Pillars = () => (
  <section id="pillars" data-testid="pillars-section" className="bg-[var(--orange)]">
    <div className="mx-auto max-w-6xl px-5 py-20">
      <SectionHead no="04" title="4 大配合" sub="需要名人堂動哪幾塊、找誰負責" light />
      <div className="mt-10 grid gap-4 md:grid-cols-2">
        {PILLARS.map((p, i) => (
          <a key={p.no} href={`#group-${i + 1}`} data-testid={`pillar-card-${i + 1}`} className="lift block rounded-3xl bg-white p-7">
            <div className="flex items-start gap-5">
              <span className="text-5xl font-black leading-none text-[var(--orange)]">{p.no}</span>
              <div>
                <h3 className="text-xl font-black text-[var(--ink)] md:text-2xl">{p.title}</h3>
                <p className="mt-2 text-[var(--text)]">{p.text}</p>
                {p.note && <p data-testid={`pillar-note-${i + 1}`} className="mt-1 text-xs text-[var(--muted)]">{p.note}</p>}
                <span className="owner-tag mt-4"><UserRound size={14} /> {p.owner}</span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);
